import SectionForm, { useFormContext } from "../SectionForm"
import { Checkbox, Input} from "@/components/ui"

const fields = [
  // Partie 1
  {name: "pieces", label: "Pièces"}, 
  {name: "chambres", label: "Chambres"},
  {name: "salle_de_bain", label: "Salle de bain"},
  // Partie 2
  {name: "salle_de_douche", label: "Salle de douche"}, 
  {name: "wc", label: "WC"},
  {name: "parking", label: "Parking"},
  // Partie 3
  {name: "terrasse", label: "Terrasse" },
  {name: "veranda", label: "Véranda" },
  {name: "balcon", label: "Balcon"},
  {name: "grenier", label: "Grenier"},
  {name: "jardin", label: "Jardin"},
  {name: "cave", label: "Cave"},
  {name: "piscine", label: "Piscine"},
  {name: "cellier", label: "Cellier"},
  {name: "spa", label: "Spa"},
  {name: "buanderie", label: "Buanderie"},
  {name: "garage", label: "Garage"}
]

const FormContent = () => {
  const { control } = useFormContext()
  return (
    <>
      <div className="flex flex-col items-center gap-4">                
        {fields.slice(0,3).map( ({name, label}, index) => (
            <Input.Text key={index}
              name={name}
              control={control}
              label={label}
            />
          ))
        }
      </div>
      <div className="flex flex-col items-center gap-4">                
        {fields.slice(3,6).map( ({name, label}, index) => (
            <Input.Text key={index}
              name={name}
              control={control}
              label={label}
            />
          ))
        }
      </div>
      <div className="space-y-4">
        <div className="grid grid-cols-2 gap-2">
          {fields.slice(6).map(
            ({name, label}, index) => (
              <Checkbox.Form key={index} 
                control={control}
                name={name}
                label={label}
              />
            ))
          }
        </div>
      </div>
    </>
  )
}

const Form = ({ title = "", onClose = () => {}, onSuccess = () => {} }) => {
  return (
    <SectionForm
      title={title}
      onClose={onClose}
      onSuccess={onSuccess}
      fields={fields.map( f => f.name)}
    >
      <FormContent/>
    </SectionForm>
  )
}

export default Form